import { mapGetters } from 'vuex';
import { MappedTypes } from '@ply-io/conditions';
import { getService } from '@/store/modules/apps/getters';
import { getAction } from '@/store/modules/actions/getters';

const SOURCE_KEY = 'source';
const VALUE_KEY = 'conditionValue';

export default {
	mixins: [],
	props: {
		conditionGroup: { type: Object },
		canRemove: { type: Boolean, default: true },
		param: { type: Object },
		node: { type: Object },
		items: { type: Array },
		readonly: { type: Boolean },
		sourceOfList: { type: String },
		isConditionDependsOnTable: {
			type: Boolean,
		},
	},
	computed: {
		...mapGetters([getService.fullPath, getAction.fullPath]),
		componentProps() {
			return {
				...this.$attrs,
				service: this.nodeService,
				node: this.node,
				action: this.nodeAction,
				readonly: this.readonly,
				conditionParamsMap: this.paramsMap,
				isConditionDependsOnTable: this.isConditionDependsOnTable,
				sourceOfList: this.sourceOfList,
			};
		},
		componentListeners() {
			const UPDATE_INPUT_FIELD = 'update-input-field';
			return { [UPDATE_INPUT_FIELD]: this.OnChangeWithPayload };
		},
		nodeService() {
			return this[getService.fullPath](this.node.service);
		},
		nodeAction() {
			return this[getAction.fullPath](this.node.action);
		},
		sourceParamType() {
			return {
				...this.param,
				...{ dataInputKey: `${SOURCE_KEY}_${this.conditionGroupId}`, key: SOURCE_KEY, description: 'Condition source' },
			};
		},
		valueParamType() {
			return {
				...this.param,
				...{ dataInputKey: `${VALUE_KEY}_${this.conditionGroupId}`, key: VALUE_KEY, description: 'Condition value' },
			};
		},
		paramsMap() {
			return { [SOURCE_KEY]: this.source, [VALUE_KEY]: this.conditionValue };
		},
		tableItems() {
			return this.items;
		},
		showValueInput() {
			return this.condition?.count === 1;
		},
		selectOptions() {
			return MappedTypes.conditions.map((x) => this.getConditionOperator(x.value, x.text, x.valuesCount));
		},
		conditionGroupId() {
			return this.conditionGroup?.id;
		},
	},
	methods: {
		getConditionOperator(operator, displayText, count) {
			return {
				operator,
				displayText,
				count,
			};
		},
		OnChangeWithPayload(payload) {
			const newValue = payload.map.value;
			const currentValue = this[payload.map.key];
			if (newValue !== currentValue) {
				this[payload.map.key] = newValue;
				this.onChange();
			}
		},
		onChange() {
			const { source, conditionValue, condition } = this;
			const toUpdate = { ...this.conditionGroup, ...{ source, conditionValue, condition: condition?.operator } };
			Object.assign(this.conditionGroup, toUpdate);
			this.$emit('onUpdate', toUpdate);
		},
		getSingularClassName(id) {
			// "You are allowed to use IDs that start with a digit in your HTML5 documents"
			return 'not-a-digit-' + id;
		},
		setInitialConditionValues() {
			this.source = this.conditionGroup?.source || '';
			this.condition = this.conditionGroup?.condition ? this.initialConditionOption() : null;
			this.conditionValue = this.conditionGroup?.conditionValue || '';
		},
		initialConditionOption() {
			return this.selectOptions.find((x) => x.operator === this.conditionGroup.condition) || this.conditionGroup.condition;
		},
	},
	mounted() {
		this.setInitialConditionValues();
	},
	data: () => ({
		source: '',
		condition: null,
		conditionValue: '',
	}),
};
